import React from 'react';
import { AccreditationFirst, IndependentQualification, AddWalletQualification } from './views/Pages/InvestorQualification';
import { OpportunitiesPage, DocusignRedirect } from './views/Pages/Investment';
import { configs } from './config';

const InvestmentHandler = React.lazy(() => import('./views/Pages/Investment/components/InvestmentHandler'));
const InvestmentWizardMicrofrontend = React
  .lazy(() => import('./views/Pages/Investment/components/InvestmentWizardMicrofrontend'));
const Home = React.lazy(() => import('./views/Pages/Home'));
const Notifications = React.lazy(() => import('./views/Pages/Notifications'));
const Login = React.lazy(() => import('./views/SystemPages/Login'));
const Authorize = React.lazy(() => import('./views/SystemPages/Authorize'));
const ServiceUnavailable = React.lazy(() => import('./views/SystemPages/ServiceUnavailable'));
const AccreditationPending = React.lazy(() => import('./views/Pages/AccreditationPending/AccreditationPending'));
const PrivacyPolicy = React.lazy(() => import('./views/SystemPages/PrivacyPolicy'));
const Liquidity = React.lazy(() => import('./views/Pages/Liquidity'));
const Portfolio = React.lazy(() => import('./views/Pages/Portfolio'));
const PendingApproval = React.lazy(() => import('./views/Pages/PendingApproval'));
const Documents = React.lazy(() => import('./views/Pages/Documents'));
const TokenDetails = React.lazy(() => import('./views/Pages/TokenDetails'));
const TakersPage = React.lazy(() => import('./views/Pages/TakerPage'));
const FAQ = React.lazy(() => import('./views/SystemPages/FAQ'));
const NotAuthorized = React.lazy(() => import('./views/Pages/NotAuthorized'));
const PageNotFound = React.lazy(() => import('./views/SystemPages/PageNotFound'));
const OpportunitiesDetailsPage = React
  .lazy(() => import('./views/Pages/Investment/components/OpportunitiesDetailsPage/OpportunitiesDetailsPage'));
const OpportunitiesDetailsMFEPage = React
  .lazy(() => import('./views/Pages/Investment/components/OpportunityDetailsMFE'));

const routes = [
  { path: '/', exact: true, name: 'Home' },
  {
    path: '/opportunities', exact: true, name: 'Opportunities', component: OpportunitiesPage,
  },
  {
    path: '/opportunity/:id',
    name: 'Opportunity',
    component: configs.ENABLE_OPPORTUNITY_DETAILS_MFE ? OpportunitiesDetailsMFEPage : OpportunitiesDetailsPage,
    exact: true,
  },
  {
    path: '/opportunity/:id/investment',
    name: 'Investment Opportunity',
    component: configs.ENABLE_INVESTMENT_MFE ? InvestmentWizardMicrofrontend : InvestmentHandler,
    exact: false,
  },
  {
    path: '/docusign-redirect', exact: true, name: 'docusign-redirect', component: DocusignRedirect,
  },
  { path: '/home', name: 'Home', component: Home },
  {
    path: '/portfolio', exact: true, name: 'Portfolio', component: Portfolio,
  },
  {
    path: '/pending', secure: false, exact: true, name: 'pending', component: PendingApproval,
  },
  {
    path: '/verify-profile', secure: false, exact: true, name: 'Verify Profile', component: AccreditationPending,
  },
  {
    path: '/portfolio/:id',
    name: 'Token details',
    component: TokenDetails,
    exact: false,
  },
  {
    path: '/liquidity', name: 'Liquidity', component: Liquidity,
  },
  {
    path: '/notifications', name: 'Notifications', component: Notifications,
  },
  {
    path: '/login', secure: false, exact: true, name: 'Login', component: Login,
  },
  {
    path: '/takers-page/:domain/:gaslimit', exact: true, name: 'TakersPage', component: TakersPage, secure: false,
  },
  {
    path: '/service-unavailable', secure: false, exact: true, name: 'Service Unavailable', component: ServiceUnavailable,
  },
  {
    path: '/authorize', secure: false, exact: true, name: 'Authorize Access', component: Authorize,
  },
  {
    path: '/privacy-policy', secure: false, exact: true, name: 'PrivacyPolicy', component: PrivacyPolicy,
  },
  {
    path: '/investor-qualification', exact: true, name: 'InvestorQualification', component: AccreditationFirst,
  },
  {
    path: '/independent-qualification', exact: true, name: 'IndependentQualification', component: IndependentQualification,
  },
  {
    path: '/authorise-wallet-qualification', exact: true, name: 'AddWalletQualification', component: AddWalletQualification,
  },
  {
    path: '/documents', exact: true, name: 'Documents', component: Documents,
  },
  {
    path: '/faq', exact: true, name: 'FAQ', component: FAQ,
  },
  {
    path: '/not-authorized', secure: false, exact: true, name: 'NotAuthorized', component: NotAuthorized,
  },
  {
    path: '/404',
    exact: true,
    secure: false,
    name: '',
    component: PageNotFound,
  },
];

export default routes;
